import React, { useEffect } from "react";
import { Formik, useFormikContext } from "formik";
import { FEATURE_GROUPS_SCHEMA } from "constants/validation";
import FeatureTableDragContainer from "components/FeaturesSection/FeatureTableDragContainer";
import {
  getFeaturesFormInitialValues,
  scaffoldFeatureGroupFeatures
} from "utils/feature";
import cloneDeep from "lodash/cloneDeep";

/**
 * Initialize the form with a scaffolded featureGroups and features to promote interaction
 * Goal is to help someone have a full featured page asap from onboarding
 */
const FeatureTableInitializer = ({ hideSaveAction, products, tracking }) => {
  const { values, setValues, setTouched } = useFormikContext();

  useEffect(() => {
    if (
      !values.features.length &&
      !values.featureGroups.length &&
      values.productLayout.length
    ) {
      const updatedValues = cloneDeep(values);
      const layoutProducts = updatedValues.productLayout.reduce(
        (memo, { uid }) => {
          const productMatch = products.find(({ id }) => id === uid);
          if (productMatch) {
            memo.push(productMatch);
          }
          return memo;
        },
        []
      );
      const entitlements = {};
      const { features, featureGroups } = scaffoldFeatureGroupFeatures(
        layoutProducts,
        entitlements
      );
      updatedValues.features = features;
      updatedValues.featureGroups = featureGroups;

      setValues(updatedValues);
      setTouched({ features: true, featureGroups: true });
    }
  }, []);

  return (
    <FeatureTableDragContainer
      hideSaveAction={hideSaveAction}
      products={products}
      tracking={tracking}
    />
  );
};

const TemplateFeatureTablePreview = ({
  features,
  featureGroups,
  products,
  productLayout,
  innerRef,
  onSubmit,
  tracking
}) => {
  const initialValues = getFeaturesFormInitialValues({
    features,
    featureGroups,
    productLayout
  });

  return (
    <Formik
      innerRef={innerRef}
      validationSchema={FEATURE_GROUPS_SCHEMA}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {() => (
        <FeatureTableInitializer
          hideSaveAction={Boolean(onSubmit)}
          products={products}
          tracking={tracking}
        />
      )}
    </Formik>
  );
};

export default TemplateFeatureTablePreview;
